import React, { useState, useEffect } from 'react';
import { testimonials } from '../utils/testimonials';
import { Row, Col } from 'react-bootstrap';

function TestimonialsSection() {
  const [start, setStart] = useState(0);
  const [isMobile, setIsMobile] = useState(false);
  
  // Check if mobile on mount and resize
  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 768);
    };
    
    checkMobile();
    window.addEventListener('resize', checkMobile);
    
    return () => window.removeEventListener('resize', checkMobile);
  }, []);
  
  // Adjust visible items based on screen size
  const visible = isMobile ? 1 : 3;
  const end = start + visible;
  const canPrev = start > 0;
  const canNext = end < testimonials.length;
  
  const handlePrev = () => canPrev && setStart(start - (isMobile ? 1 : 1));
  const handleNext = () => canNext && setStart(start + (isMobile ? 1 : 1));

  return (
    <section className="testimonials-section">
      <div className="testimonials-inner">
        <div className="testimonials-title-wrap">
          <h2 className="testimonials-title">Testimonials</h2>
          <div className="testimonials-title-underline"></div>
        </div>
        <div className="testimonials-subtitle">Read what our clients say about us!</div>
        <div className="testimonials-carousel-wrap">
          <button className="testimonials-nav testimonials-nav-left" onClick={handlePrev} disabled={!canPrev}>
            <span>&lt;</span>
          </button>
          <div className="testimonials-carousel">
            {testimonials.slice(start, end).map((t, idx) => (
              <div className="testimonial-card" key={idx}>
                <div className="testimonial-avatar-wrap">
                  <img src={t.avatar} alt={t.name} className="testimonial-avatar" />
                </div>
                <div className="testimonial-stars">
                  {Array.from({ length: t.stars }).map((_, i) => (
                    <span className="testimonial-star" key={i}>★</span>
                  ))}
                </div>
                <div className="testimonial-text">{t.text}</div>
                <div className="testimonial-name">{t.name}</div>
              </div>
            ))}
          </div>
          <button className="testimonials-nav testimonials-nav-right" onClick={handleNext} disabled={!canNext}>
            <span>&gt;</span>
          </button>
        </div>
      </div>
    </section>
  );
}

export default TestimonialsSection; 